import {
  SET_CLAIM_COUNT_TASK,
  SET_LAYOUT,
  SET_LOADING,
  SET_PAGE_NAME_LAYOUT,
  SET_ORDER_TASK,
  SET_TOS_TASK,
  SET_LIST_TOS_TASK,
} from "../reducers/actionType";
import { get } from "../components/common/customAxios";

export function setLayout(layout) {
  return {
    type: SET_LAYOUT,
    payload: layout,
  };
}

export function setLoading(loading) {
  return {
    type: SET_LOADING,
    payload: loading,
  };
}

export function fetchClaimCountTask(username = "") {
  return (dispatch) => {
    return get("/api/claim/getCountTask" + username).then((response) => {
      dispatch({
        type: SET_CLAIM_COUNT_TASK,
        payload: response || {},
      });
    });
  };
}

export function fetchOrderTask() {
  return (dispatch) => {
    return get("/api/Order/GetBadge").then((response) => {
      dispatch({
        type: SET_ORDER_TASK,
        payload: response || {},
      });
    });
  };
}

export function fetchTosTask() {
  return (dispatch) => {
    return get("/api/tos/GetTosTask").then((response) => {
      dispatch({
        type: SET_TOS_TASK,
        payload: response || {},
      });
    });
  };
}

export function fetchListTosTask() {
  return (dispatch) => {
    return get("/api/tos/GetListTosTask").then((response) => {
      dispatch({
        type: SET_LIST_TOS_TASK,
        payload: response || {},
      });
    });
  };
}

export function setPageName(page) {
  return {
    type: SET_PAGE_NAME_LAYOUT,
    payload: page,
  };
}
